import React, { useState, useEffect } from "react";
import "./styles.css";
import { projectImages } from "../utils/helpers";
import ImageSwiper from "./Swiper";
import ProjectList from "../Data/Projects";

const Home = () => {
  const [swiper_images, setSwiperImages] = useState([]);
  useEffect(() => {
    const swiper_images = Object.keys(ProjectList)
      .filter(
        (projectId) =>
          ProjectList[projectId] &&
          ProjectList[projectId].publish &&
          ProjectList[projectId].showInHomePage,
      )
      .map((projectId) => {
        return projectImages[projectId]?.find((img) =>
          img.src.includes(ProjectList[projectId]["bannerImageName"]),
        ).src;
      });
    setSwiperImages(swiper_images);
    //   document.querySelector(".navbar").classList.add("homepage");
    return () => {
      //     document.querySelector(".navbar").classList.remove("homepage");
    };
  }, []);
  return (
    <section
      style={{
        overflow: "clip",
      }}
    >
      <ImageSwiper images={swiper_images} />
    </section>
  );
};

export default Home;
